import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { MaterialRenderer } from '../../MaterialRenderer/MaterialRenderer';
import { ICourseStructureDTO } from '../../../../../api/private/learn-engine-api/learn-engine-api.interface';

import s from './LandingPageCourse.scss';

interface ILandingPageCourseProps {
	data: ICourseStructureDTO;
}

export function LandingPageCourse({
	data,
}: ILandingPageCourseProps): JSX.Element {
	useStyles(s);
	return (
		<div className="lp-landing-page-course">
			<MaterialRenderer materialInfo={data?.materialInfo}>
				{data?.children}
			</MaterialRenderer>
		</div>
	);
}
